import styled from "styled-components";
import IComponentForm from "./interface";

const Container = styled.form<IComponentForm>`
  width: 100%;
  height: 100%;
  ${(props) => props.styleInline}
`;

export default Container;
